import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { imgBase, getDelivTypesReq, rmDelivTypeReq, updDelivTypeReq, addDelivTypeReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { defImg } from '../config/globals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faSpinner, faTrashAlt, faCamera } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';

class DelivTypes extends React.Component {
	constructor(props) {
		super(props);

		this.imgInputRef = React.createRef();
		this.player = React.createRef();

		this.state = {
			name: '',
			image: '',
			img: null,
			types: null,
			errors: { name: '', image: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			id: '',
		};
	}

	componentDidMount() {
		this.getDelivTypes();
	}

	getDelivTypes = () => {
		this.setState({fetchLoading: true});
		getDelivTypesReq()
		.then( (res) => {
			this.setState({types: res.data, form: false});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch types");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	rmType = (id, index) => {
		this.setState({deleteLoading: true});
		rmDelivTypeReq({id})
		.then( (res) => {
			const { types } = this.state;
			types.splice(index, 1);
			this.setState({types});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not remove type");
		}).finally( () => {
			this.setState({deleteLoading: false});
		});
	}
	
	handleChange = ({ target: { name, value } }) => {
		this.setState({[name]: value});
	}

	validate = () => {
		const { name, image } = this.state;
		let errors = { name: '', image: '' }, isValid = true;

		if(!name) {
			errors.name = "Enter name to continue";
			isValid = false;
		}
		if(!image) {
			errors.image = "Upload image to continue";
			isValid = false;
		}

		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		let { id, name, image, img } = this.state;
		if(this.validate()) {
			if(img && !img.name) {
				img = new File([img], `${name}.${img.type.split("/")[1]}`);
			}
			if(id) {
				this.setState({loading: true});
				const formData = new FormData();
				formData.append('id', id);
				formData.append('name', name);
				formData.append('img', img);
				formData.append('image', img ? img.name || `${name}.${img.type.split("/")[1]}` : image);
				updDelivTypeReq(formData)
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Type updated");
					this.getDelivTypes();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			} else {
				this.setState({loading: true});
				const formData = new FormData();
				formData.append('name', name);
				formData.append('img', img);
				formData.append('image', img ? img.name || `${name}.${img.type.split("/")[1]}` : image);
				addDelivTypeReq(formData)
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Type added");
					this.getDelivTypes();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			}
		}
	}

	navigateAdd = () => {
		this.setState({ id: '', name: '', image: '', img: null, errors: {name: '', image: ''}, loading: false, form: true });
	}

	navigateEdit = (id, name, image) => {
		this.setState({ id, name, image, img: null, errors: {name: '', image: ''}, loading: false, form: true });
	}

	onChangeFile = (e) => {
		if (e.target.files.length > 0) {
			let fileName = e.target.files[0].name;
			this.getBase64(e.target.files[0], (res) => {
				this.setState({ [e.target.name]: res, img: e.target.files[0] });
			});
		}
	}

	getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
	
	initializeMedia = async () => {
		this.setState({ img: null, image: '' });
	
		if (!("mediaDevices" in navigator)) {
		  navigator.mediaDevices = {};
		}
	
		if (!("getUserMedia" in navigator.mediaDevices)) {
		  navigator.mediaDevices.getUserMedia = function (constraints) {
			var getUserMedia =
			  navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
	
			if (!getUserMedia) {
			  return Promise.reject(new Error("getUserMedia Not Implemented"));
			}
	
			return new Promise((resolve, reject) => {
			  getUserMedia.call(navigator, constraints, resolve, reject);
			});
		  };
		}
	
		//Get the details of video inputs of the device
		const videoInputs = await this.getListOfVideoInputs();
	
		//The device has a camera
		if (videoInputs.length) {
		  navigator.mediaDevices
			.getUserMedia({
			  video: {
				deviceId: {
				  exact: videoInputs[0].deviceId,
				},
			  },
			})
			.then((stream) => {
			  this.player.srcObject = stream;
			})
			.catch((error) => {
			  console.error(error);
			});
		} else {
		  alert("The device does not have a camera");
		}
	  };
	
	  capturePicture = async () => {
		var canvas = document.createElement("canvas");
		canvas.width = this.player.videoWidth;
		canvas.height = this.player.videoHeight;
		var contex = canvas.getContext("2d");
		contex.drawImage(this.player, 0, 0, canvas.width, canvas.height);
		this.player.srcObject.getVideoTracks().forEach((track) => {
		  track.stop();
		});
	
		// console.log(canvas.toDataURL());
		const image = canvas.toDataURL();
		const img = await fetch(image).then((res) => res.blob());
		this.setState({ img, image });
	  };

	render() {
		const { id, name, image, img, types, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, rmType, onChangeFile, imgInputRef } = this;
		return (
			form ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>{id ? 'Update ' : 'Add '} Deliverer Type</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group style={{position: 'relative'}}>
										<Form.Control name="image" onChange={onChangeFile} type="file" style={{display: 'none'}} ref={imgInputRef} />
										{image ?
											img ?
												<>
												<Image fluid  style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}} onClick={() => {imgInputRef.current.click()}} src={image} />
												<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', left: '25%', bottom: 0}} onClick={() => {this.capturePicture()}}>
													<FontAwesomeIcon icon={faCamera} />
												</button>
												<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', right: '25%', bottom: 0}} onClick={() => {imgInputRef.current.click()}}>
													<FontAwesomeIcon icon={faPlus} />
												</button>
												</>
											:
												<>
												<Image fluid  style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}} onClick={() => {imgInputRef.current.click()}} src={`${imgBase}${image}`} />
												<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', left: '25%', bottom: 0}} onClick={() => {this.capturePicture()}}>
													<FontAwesomeIcon icon={faCamera} />
												</button>
												<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', right: '25%', bottom: 0}} onClick={() => {imgInputRef.current.click()}}>
													<FontAwesomeIcon icon={faPlus} />
												</button>
												</>
										: this.state.camming ?
											<>
											<video
												ref={(refrence) => {this.player = refrence;}}
												autoPlay
												style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}}
											></video>
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', left: '25%', bottom: 0}} onClick={() => {this.capturePicture()}}>
												<FontAwesomeIcon icon={faCamera} />
											</button>
											</>
										:
											<>
											<Image fluid  style={{marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer'}} src={defImg} />
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', left: '25%', bottom: 0}} onClick={() => {this.initializeMedia()}}>
												<FontAwesomeIcon icon={faCamera} />
											</button>
											<button type="button" className="btn-success btn btn-circle" style={{position: 'absolute', right: '25%', bottom: 0}} onClick={() => {imgInputRef.current.click()}}>
												<FontAwesomeIcon icon={faPlus} />
											</button>
											</>
										}
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={name} error={errors.name} name="name" label="Name" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			:
				<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
					<Col md={12} style={{justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px'}}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Deliverer Type
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(types) ?
						types.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Image</th>
											<th>Name</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{types.map(({ id, name, image }, i) =>
											<tr key={i}>
												<td>
													<Image fluid  style={{width: 50, height: 50}} src={`${imgBase}${image}`} />
												</td>
												<td>{name}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, name, image) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmType(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						:
							<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No deliverer types found.</p>
					:
						<></>
					}
				</Row>
		);
	}
}

export default DelivTypes;